<script>
    import DraftIcon from "./assets/draft.svg";
    import QualifyIcon from "./assets/qualify.svg";
    import ReviewIcon from "./assets/review.svg";
    import InterviewIcon from "./assets/defend.svg";

    import DraftPicture from "./assets/features/Draft Picture 4.png";
    import QualifyPicture from "./assets/features/Qualify Picture 1.png";
    import ReviewPicture from "./assets/features/Review Picture 1.png";
    import InterviewPicture from "./assets/features/Interview Picture 2.png";

    let activeTab = 0;

    const tabs = [
        {
            name: "Draft",
            icon: DraftIcon,
            image: DraftPicture,
            imageOffset: "0px",
            description: "AI drafts AIF technical narratives within seconds, based solely on input provided.",
        },
        {
            name: "Qualify",
            icon: QualifyIcon,
            image: QualifyPicture,
            imageOffset: "0px",
            description: "AI identifies risks & gaps; suggests questions in customer-friendly language.",
        },
        {
            name: "Review",
            icon: ReviewIcon,
            image: ReviewPicture,
            imageOffset: "0px",
            description: "AI provides comprehensive, tailored feedback on narratives, helping to make them even stronger.",
        },
        {
            name: "Interview",
            icon: InterviewIcon,
            image: InterviewPicture,
            imageOffset: "0px",
            description: "AI transcribes technical interviews in real-time, and takes notes like a R&D colleague.",
        },
    ];
</script>

<div class="max-w-6xl mx-auto px-6 md:px-16">
    <div class="md:grid md:grid-cols-2 gap-12 items-center">

        <!-- Left: gradient panel with screenshot (Figma node 2034:321) -->
        <div class="rounded-[8px] overflow-hidden relative"
            style="background: linear-gradient(-9.64deg, rgb(229,231,251) 4.4%, rgb(242,241,234) 86.8%); aspect-ratio: 603/430;">
            <!-- Card centered both axes -->
            <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[12px] overflow-hidden bg-white"
                style="width: 82%; height: 70%; box-shadow: 0px 1px 12px 0px rgba(48,49,133,0.2);">
                <img
                    src={tabs[activeTab].image}
                    alt={tabs[activeTab].name}
                    class="absolute max-w-none left-[-0.02%]"
                    style="top: {tabs[activeTab].imageOffset ?? '0px'}; width: 197.05%; height: auto;"
                />
            </div>
        </div>

        <!-- Right: vertical tab list (Figma node 2034:325 for active state) -->
        <div class="mt-8 md:mt-0 space-y-1">
            {#each tabs as tab, i}
                <button
                    class="w-full text-left transition-all {activeTab === i
                        ? 'border-l-[3px] border-purple-sub py-5 pl-8 pr-5'
                        : 'py-5 px-5 rounded-xl opacity-50 hover:opacity-70'}"
                    on:click={() => (activeTab = i)}
                >
                    <div class="flex items-center gap-3">
                        <img src={tab.icon} alt="" class="w-5 h-5 flex-shrink-0" />
                        <span class="text-[20px] font-medium text-black">{tab.name}</span>
                    </div>
                    {#if activeTab === i}
                        <p class="mt-2 text-[18px] text-navy leading-snug ml-8">{tab.description}</p>
                    {/if}
                </button>
            {/each}
        </div>
    </div>
</div>
